
<div style="margin-top: 10%; padding:10px; text-align: center;">

    <div style="margin-bottom: 2rem;">
        <img [src]="'/apps/error.svg'" width="100" align="center">
    </div>
    <div style="display:flex; flex-direction:column; align-items: center; ">
        <div style="font-size: x-large; margin-bottom: 1rem;">Somthing went wrong</div>
        <div>Please go back and submit the signup form again.</div>
        <div>If you keep seeing this error, please contact us.</div>
        <div (click)="back()"
            style="margin-top: 3rem; 
            cursor: pointer; 
            text-decoration: underline;">
            Back
        </div>
        
        
    </div>


</div>

